import { DepartmentRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * customerOnSaveData - Function that saves on database an new department  
 * /departments  
 * method POST  
 * @async-function
 */
const departmentOnSaveData = async (token: string, model: DepartmentRequestType) => {
    const response = await api.post(
        `/departments`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default departmentOnSaveData;